export default {
  Put: 'PUT',
  Post: 'POST',
}
